module.exports = __webpack_public_path__ + "img/homegoogle2.96aa8810.svg";